import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Button
} from '@mui/material';

import { FaCheckCircle } from "react-icons/fa";
import { FaExclamationTriangle } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";
import { PopupType } from '../../common/enums';

const typeStyles = {
    success: {
        color: '#2e7d32',
        bg: '#e8f5e9',
        Icon: FaCheckCircle
    },
    warning: {
        color: '#f9a825',
        bg: '#fffde7',
        Icon: FaExclamationTriangle
    },
    error: {
        color: '#c62828',
        bg: '#ffebee',
        Icon: FaTimesCircle
    }
};

const SFPopupDialog = ({ open, handleClose, type, title, message }) => {
    const style = typeStyles[type] || typeStyles.success;
    const Icon = style.Icon;

    let color = 'primary';
    switch (type) {
        case PopupType.SUCCESS:
            color = 'success';
            break;
        case PopupType.WARNING:
            color = 'warning';
            break;
        case PopupType.ERROR:
            color = 'error';
            break;
    
        default:
            break;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: {
                    borderTop: `6px solid ${style.color}`,  // top color bar
                }
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                padding="16px 16px"
                sx={{
                    backgroundColor: style.bg,
                }}
            >
                <Icon style={{ color: style.color, marginRight: 12 }} />
                <Typography variant="h6" style={{ color: style.color, fontWeight: 600 }}>
                    {title}
                </Typography>
            </Box>

            <DialogContent>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' onClick={handleClose} color={color}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SFPopupDialog;

